import OwnersLogo from './owners-logo'
export default OwnersLogo
